import OATable from './OATable.vue'
import OAList from './OAList.vue'
import OATableOnly from './OATableOnly.vue'

const data = {
  install: function (Vue) {
    Vue.component('OATable', OATable)
    Vue.component('OAList', OAList)
    Vue.component('OATableOnly', OATableOnly)
  }
}
export default data



// WEBPACK FOOTER //
// ./src/components/OATable/index.js